import { render, staticRenderFns } from "./ModifyPassword.vue?vue&type=template&id=83ee53fe&scoped=true&lang=pug&"
import script from "./ModifyPassword.vue?vue&type=script&lang=js&"
export * from "./ModifyPassword.vue?vue&type=script&lang=js&"
import style0 from "./ModifyPassword.vue?vue&type=style&index=0&id=83ee53fe&scoped=true&lang=scss&"
import style1 from "./ModifyPassword.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83ee53fe",
  null
  
)

export default component.exports